export default __webpack_public_path__ + "static/media/leftInActive.fd4a94fa.svg";